export default __webpack_public_path__ + "static/5-583c5b9828b166098a933d26f23017be.png";